export default "__VITE_ASSET__DOyIM11m__"